import Cookies from 'js-cookie';
export async function apiRequest(url: string) {
  const tokenCookie = Cookies.get('token');
  const res = await fetch(url, {
    method: "GET",
    headers: {
      authorization: `Bearer ${tokenCookie}`,
      apikey: process.env.NEXT_PUBLIC_API_KEY,
    },
  });
  let { data } = await res.json();
  return data;
}
